/**
 * Reflect promise to get all promises result even if one failed
 *
 * @param {Promise} promise
 */
export const allSettled = promise => promise.then((response) => {
  return { response, status: 'fulfilled' }
}, (error) => {
  return { error, status: 'rejected' }
})
